import E from "./index79.mjs";
import { setRoomsAvailabilityAtom as O } from "./index34.mjs";
import { searchResultsAtom as g } from "./index58.mjs";
import { searchCriteriaAtom as v } from "./index26.mjs";
import { DEFAULT_CURRENCY as h } from "./index52.mjs";
import { getTimeFromDate as o } from "./index153.mjs";
import { useSearch as w } from "./index91.mjs";
import { useAtomValue as d, useSetAtom as D } from "jotai";
import { useState as _, useEffect as S } from "react";
const y = (t, n) => {
  if (n == null)
    return t;
  const i = t.find((m) => m.id === n);
  if (i) {
    const m = t.filter((r) => r.id !== n);
    return [i, ...m];
  }
  return t;
}, B = (t) => {
  const [n, i] = _(), [m, r] = _(h), [p, u] = _(!1), [C, k] = _(!1), [R, l] = _(!1), e = d(g), { setSearchResults: f } = w(!0), a = d(v), s = D(O);
  return S(() => {
    if (e)
      i(y(e.rooms, t)), r(e.currency || h), s({
        currency: e.currency || h,
        checkInTime: o(e.check_in_time),
        checkInEndTime: o(e.check_in_end_time),
        checkOutTime: o(e.check_out_time),
        checkOutEndTime: o(e.check_out_end_time),
        checkInInfo: e.check_in_info,
        showCheckInCheckOutTime: e.show_check_in_check_out_time
      }), k(e.hotel_city_tax), l(e.hotel_city_tax_included), u(
        e.consent_communication_checkbox
      );
    else {
      const {
        arrivalDate: T,
        departureDate: x,
        totalAdults: A,
        totalChildren: I,
        promoCode: b
      } = a;
      E.getRoomAvailability(
        T,
        x,
        A,
        I,
        b
      ).then((c) => {
        f(c), i(y(c.rooms, t)), c.rooms.length && (r(c.currency || h), s({
          currency: c.currency || h,
          checkInTime: o(c.check_in_time),
          checkInEndTime: o(c.check_in_end_time),
          checkOutTime: o(c.check_out_time),
          checkOutEndTime: o(c.check_out_end_time),
          checkInInfo: c.check_in_info,
          showCheckInCheckOutTime: c.show_check_in_check_out_time
        }), k(c.hotel_city_tax), l(c.hotel_city_tax_included), u(
          c.consent_communication_checkbox
        ));
      }).catch(() => {
        i([]);
      });
    }
  }, [
    a,
    s,
    e,
    f,
    t
  ]), {
    rooms: n,
    currency: m,
    searchInputs: a,
    applyCityTaxRule: C,
    cityTaxIncludedAllRooms: R,
    consentCommunicationCheckbox: p
  };
};
export {
  B as useResults
};
